import { FareTypeObjects } from '../constants/FareTypes';

import { FareClass, FareClassType } from './types';

export const getFareClassFromSubType = (subType: number, type: FareClassType): FareClass | undefined =>
  Object.values(FareTypeObjects).find((f) => f.type === type && f.subType === subType);

export const getNormalFareClassFromSubType = (st: number) => getFareClassFromSubType(st, 'normal');
